import { useState } from 'react';
import { useApi } from '../contexts/ApiContext';

export interface AckRef { kind: string; subject_id: string; state: string; label: string; domain_id: string | null }
export interface Acknowledged extends AckRef { id: string; comment: string; by: string; at: string }

/** Acknowledge an item with a comment (why it's fine / in hand). */
export default function AckForm({ ack, onDone, onCancel }: { ack: AckRef; onDone: () => void; onCancel: () => void }) {
  const { fetchApi } = useApi();
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async () => {
    setBusy(true); setError(null);
    try {
      await fetchApi('/reports/attention/acks', { method: 'POST', body: JSON.stringify({ ...ack, comment }) });
      onDone();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not acknowledge');
      setBusy(false);
    }
  };
  return (
    <div className="mt-1 mb-2 space-y-2 rounded-md border border-slate-200 bg-slate-50 p-2.5">
      <label className="block text-xs font-medium text-slate-600" htmlFor={`ack-${ack.kind}-${ack.subject_id}`}>Acknowledge <span className="font-semibold text-slate-800">{ack.label}</span> — why is it fine or in hand?</label>
      <textarea id={`ack-${ack.kind}-${ack.subject_id}`} className="input min-h-[60px] text-sm" autoFocus maxLength={500} value={comment} onChange={(e) => setComment(e.target.value)}
        placeholder="e.g. Letting it lapse · Card replaced, retrying Monday · Sold to client" />
      {error && <p className="text-xs text-red-600">{error}</p>}
      <div className="flex gap-2">
        <button type="button" className="btn btn-primary !py-1 text-xs" disabled={busy || !comment.trim()} onClick={submit}>Acknowledge</button>
        <button type="button" className="btn btn-secondary !py-1 text-xs" onClick={onCancel}>Cancel</button>
      </div>
      <p className="text-[11px] text-slate-400">Hidden from the counts and the digest until it changes (new expiry, new failure…), then it comes back.</p>
    </div>
  );
}

